<template>

    <dialog-fullscreen :visibility.sync='visibility' :indicator='indicator'>
        <template v-slot:title>Добавление фразы</template>
        <template v-slot:action>
            <v-btn
                    text
                    :disabled = '!wordstatplace.phrases.length || !wordstatplace.user_login'
                    :loading = 'indicator'
                    color='green darken-2'
                    @click="createWordstatplace"
            >
                Добавить
            </v-btn>
        </template>
        <template v-slot:content>

            <v-form v-model='validStatplace' style='min-width: 320px; max-width: 420px;'>

                <v-autocomplete
                        :loading = 'ya.list'
                        :items = 'ya.accounts'
                        label = 'Аккунт Яндекса'
                        v-model = "wordstatplace.user_login"
                        single-line
                >
                </v-autocomplete>
                <label>Фраза(ы) (Не больше 10 фраз)</label>
                <vue-tags-input
                        v-model="phrase"
                        :tags="wordstatplace.phrases"
                        :max-tags="10"
                        placeholder="Добавьте фразу"
                        required
                        @tags-changed="newPhrases => wordstatplace.phrases = newPhrases"
                />
                <br>
                <label>Выберите регион(ы)</label>
                <treeselect
                        v-model="wordstatplace.geo_id"
                        :multiple="true"
                        :options="regions"
                        :normalizer="normalize"
                        placeholder="Выберите регион(ы)"
                        return-object
                />

            </v-form>

        </template>

    </dialog-fullscreen>

</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import VueTagsInput from '@johmun/vue-tags-input';
    import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {

        name: 'WordstatplaceCreateMenu',
        props: ['postAction', 'project', 'initialState'],
        components: {'dialog-fullscreen': DialogFullscreen, VueTagsInput, Treeselect},
        data() {
            return {
                validStatplace: false,
                visibility: this.initialState,
                indicator: false,
                phrase: '',
                wordstatplace: {
                    project_id: this.project.project_id,
                    vertical_id: this.project.vertical_id,
                    phrases: [],
                    geo_id: []
                },
                regions: [],
                flat_regions: [],
                ya: {
                    list: false,
                    get: false,
                    credentials: {},
                    accounts: [],
                    counters: [],
                    selection: {}
                },

            }
        },
        computed: {
            valid() {
                console.log()
            }
        },
        methods: {
            normalize(node) {
                return {
                    id: node.region_id,
                    label: node.region_name,
                    children: node.children
                }
            },
            getRegions() {
                this.$http.get(this.$store.getters.endpoint + '/db/list', {
                    emulateJSON: true,
                    params: {'login': this.$store.getters.userLogin, 'kind': 'regions'},
                    headers: this.$store.state.restrictedHeaders
                }).then(
                    r => {
                        let response = r.body;
                        if (response.result) {
                            this.regions = response.data.grouped_data;
                            this.flat_regions = response.data.flat_data;
                        } else {
                            console.log(response)
                        }
                    }
                )
            },
            fillDefault() {
                this.wordstatplace = {
                    project_id: this.project.project_id,
                    vertical_id: this.project.vertical_id,
                    phrases: [],
                    geo_id: []
                }
            },
            dd() {
                console.log(this.wordstatplace)
                const l = this.wordstatplace.phrases;
                console.log(l)
            },
            openAuthWindow(target) {
                let target_link = `https://oauth.service.artics.ru/connect/${target}`
                let oaw = window.open(target_link)
                oaw.postMessage(`${target}_ouath2_flow_initiated`, `https://oauth.service.artics.ru/connect/${target}`)
            },
            getYACredentials() {
                this.ya.list = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                }
                this.$http.put(this.$store.getters.endpoint + '/db/connect_ya',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.ya.list = false;
                        this.ya.accounts = response.list
                    } else {
                        console.log(response)
                    }
                })
            },
            createWordstatplace() {
                this.indicator = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                const requestData = {
                    login: this.$store.getters.userLogin
                }
                const i = {
                    project_id: this.project.project_id,
                    vertical_id: this.project.vertical_id,
                    phrases: this.wordstatplace.phrases.map(el => el.text),
                    geo_id: this.flat_regions.filter(el => {
                        return this.wordstatplace.geo_id.indexOf(el.region_id) !== -1
                    }),
                    user_login: this.wordstatplace.user_login
                };
                console.log(i)
                this.$http.post(this.$store.getters.endpoint + '/db/project/' + this.project.project_id + '/wordstatplaces', {
                    ...requestData,
                    ...{ 'wordstatplace': i }
                }, {
                    headers: { ...this.$store.state.restrictedHeaders,
                        ...requestHeaders
                    }
                }).then(
                    r => {
                        this.indicator = false;
                        this.visibility = false;
                        let response = r.body;
                        if (response.result) {
                            this.postAction('wordstatplaces')
                        }else {
                            this.errorCreate = true;
                            console.log(response)
                        }
                    }, (r) => {
                        this.indicator = false;
                        let error = r.body;
                        console.log(error)
                    }
                )
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
                if (value) {
                    console.log("initialState", value);
                    this.fillDefault();
                    this.getRegions();
                    this.getYACredentials();

                }
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
        }
    }
</script>
